export const COMPONENT_NAME = 'SmartList';
